const StatistikIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22.372"
      height="22.407"
      viewBox="0 0 22.372 22.407"
    >
      <path
        id="Form_9"
        data-name="Form 9"
        d="M899.173,401.207a11.21,11.21,0,0,1-3.029-21.382,1.018,1.018,0,0,1,.813,1.867,9.164,9.164,0,1,0,12.09,11.974,1.017,1.017,0,1,1,1.873.793,11.172,11.172,0,0,1-11.747,6.748Zm1.445-10.089A1.017,1.017,0,0,1,899.6,390.1V379.913a1.018,1.018,0,0,1,1.017-1.019A11.2,11.2,0,0,1,911.8,390.1a1.017,1.017,0,0,1-1.017,1.018Zm1.017-2.037h8.078a9.158,9.158,0,0,0-8.078-8.093Z"
        transform="translate(-889.432 -378.894)"
      />
    </svg>
  );
};

export default StatistikIcon;
